import React from "react";
import { Box, Typography, Link, IconButton } from "@mui/material";
import { Facebook, LinkedIn, Instagram } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { tokens } from "../../theme";
import goldAccreditation from "./Gold_RGB.png";
import ssipAccreditation from "./ssip-supplier-logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  // The footer stays dark in both colour modes. Its tokens are deliberately pinned to the
  // dark palette rather than following theme.palette.mode: the Constructionline badge is
  // gold ink on a fully transparent background and washes out on a light backing.
  const colors = tokens("dark");

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: colors.grey[900],
        color: "white",
        padding: "10px 20px",
        textAlign: "center",
        mt: "auto",
      }}
    >
      {/* Links */}
      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "15px" }}>
        <Link component={RouterLink} to="/about" onClick={() => window.scrollTo(0, 0)} color="inherit" underline="hover">
          About Us
        </Link>
        <Link component={RouterLink} to="/privacypolicy" onClick={() => window.scrollTo(0, 0)} color="inherit" underline="hover">
          Privacy Policy
        </Link>
        <Link component={RouterLink} to="/cookiepolicy" onClick={() => window.scrollTo(0, 0)} color="inherit" underline="hover">
          Cookie Policy
        </Link>
        <Link component={RouterLink} to="/terms" onClick={() => window.scrollTo(0, 0)} color="inherit" underline="hover">
          Terms of Service
        </Link>
        <Link component={RouterLink} to="/contact" onClick={() => window.scrollTo(0, 0)} color="inherit" underline="hover">
          Contact
        </Link>
      </Box>

      {/* Social Media Icons */}
      <Box>
        <IconButton href="https://www.facebook.com/profile.php?id=100063592419485" target="_blank" color="inherit">
          <Facebook />
        </IconButton>
        <IconButton href="https://www.linkedin.com/in/aurimas-pudzemys-743869182/" target="_blank" color="inherit">
          <LinkedIn />
        </IconButton>
        <IconButton href="https://www.instagram.com/avfacades/" target="_blank" color="inherit">
          <Instagram />
        </IconButton>
      </Box>

      {/* Accreditations */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          padding: "10px 0",
        }}
      >
        <Box
          component="img"
          src={goldAccreditation}
          alt="Gold Accreditation"
          sx={{ height: "60px", width: "auto" }}
        />
        <Box
          component="img"
          src={ssipAccreditation}
          alt="SSIP Supplier Accreditation"
          sx={{ height: "60px", width: "auto" }}
        />
      </Box>

      {/* Copyright */}
      <Typography variant="body2">
        &copy; {currentYear} AV Facade Services. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;